import React from 'react';
import { connect } from 'react-redux';

import { IRIMSActions, IAddProps } from '../types';

interface IAddState {
    quantity: string;
    quantityError: boolean;
}

class Add extends React.Component<IAddProps, IAddState> {
  constructor(props) {
    super(props);
    this.state = { quantity: '1', quantityError : false };
  }

  handleShowModal = () => $('#add_inventory_request_modal').modal('show');

  handleChangeQuantity = (e) => {
    const quantity = e.target.value;
    const { inStock } = this.props;

    this.setState({ 
      quantity,
      quantityError: !/^\d+$/.test(quantity) || parseInt(quantity) > inStock || parseInt(quantity) < 1
    });
  }

  handleAddItem = () => {
    const { code, itemNumber, inStock, description } = this.props;
    const { quantity } = this.state;

    if (!/^\d+$/.test(quantity) || parseInt(quantity) > inStock || parseInt(quantity) < 1) {
      this.setState({ quantityError: true });
      return;
    }

    $('#add_inventory_request_modal').modal('hide');

    this.props.setInventoryRequest({ code, itemNumber, quantity, inStock, description })
  }

  render () {
    const { itemNumber, description, inStock } = this.props;
    const { quantity, quantityError } = this.state;

    return (
      <>
        <button className='sn-btn sn-btn-md sn-btn-teal' type='button' onClick={this.handleShowModal}>Add To Request</button>

        <div className='modal fade sn-unset-right-align' role='dialog' id='add_inventory_request_modal' tabIndex={-2} >
          <div className='modal-dialog modal-md'>
            <div className='sn-modal modal-content'>
              <form className='sn-form' >
                <div className='modal-header'>
                  <button type='button' className='close' data-dismiss='modal'>&times;</button>
                  <h3><strong>Add Request Item</strong></h3>
                </div>
                <div className='modal-body'>
                  <div className='row'>
                    <div className='form-group col-xs-12 col-sm-8'>
                      <label htmlFor='itemNumber' className='required'>Item Number</label>
                      <input type='text' className='form-control' disabled required value={itemNumber} />
                      <span className='text-gray sn-small-text'>{description}</span>
                    </div>
                    <div className='form-group col-xs-12 col-sm-4'>
                      <label htmlFor='quantity'>Quantity</label>
                      <input type='number' min={1} max={inStock} className='form-control' value={quantity} onChange={this.handleChangeQuantity} />
                      <span className='text-success sn-small-text'>In-Stock: {inStock}</span>

                      {quantityError && (
                        <span className='text-danger sn-small-text show'>
                          Number should be {'<='} {inStock}
                        </span>
                      )}
                    </div> 
                  </div>
                </div>
                <div className='modal-footer'>
                  <button type='button' className='sn-btn sn-btn-silver sn-btn-sm' data-dismiss='modal'>Close</button>
                  &nbsp;
                  <button type='button' className='sn-btn sn-btn-blue sn-btn-sm' onClick={this.handleAddItem}>Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  setInventoryRequest: (payload: any) => dispatch({ type: IRIMSActions.SetInventoryRequest, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Add);
